import { postJson } from "../Utils/apiUtils.js";

export const requestMemberActivation = ({ userId, navigate }) =>
  postJson(
    "/dashboard/user/updateActive",
    {
      userIdArr: [userId],
    },
    navigate
  );

export const requestMemberInactivation = ({ userId, navigate }) =>
  postJson(
    "/dashboard/user/updateInActive",
    {
      userIdArr: [userId],
    },
    navigate
  );

export const requestMemberDeletion = ({ userId, navigate }) =>
  postJson(
    "/dashboard/user/delete",
    {
      userIdArr: [userId],
    },
    navigate
  );

export const requestMemberInfoUpdate = ({
  userId,
  editingMemberState,
  navigate,
}) => {
  if (!editingMemberState) {
    return null;
  }

  return postJson(
    "/dashboard/user/updateMemberInfo",
    {
      userId,
      memberType: Number(editingMemberState.editMemberType),
      companyDepartmentId:
        editingMemberState.editDepartmentId === "__none__"
          ? null
          : Number(editingMemberState.editDepartmentId),
    },
    navigate
  );
};
